import React, {
  useEffect,
  useState,
} from 'react';
import {
  doc,
  getDoc,
  query,
  where,
  getDocs,
  collection,
  updateDoc,
} from 'firebase/firestore';
import {
  Title,
  Text,
  Paper,
} from '@mantine/core';
import { useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { db } from 'firebaseConfig';
import Frame from 'Components/Frame';
import VolunteerForm from 'Forms/Volunteer';
import LoadingOverlayBox from 'Components/LoadingOverlayBox';

const Update = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [volunteer, setVolunteer] = useState(null);

  useEffect(() => {
    const fetchVolunteer = async () => {
      console.log('fetchVolunteer:id', id);

      setLoading(true);

      try {
        const ref = doc(db, 'volunteers', id);
        const snapshot = await getDoc(ref);

        if (snapshot.exists()) {
          const data = snapshot.data();
          if (data.dob) {
            data.dob = new Date(data.dob.seconds * 1000 + data.dob.nanoseconds / 1000000);
          }
          setVolunteer(data);
          console.log('fetchVolunteer:data', data);
        } else {
          console.log('fetchVolunteer:data', null);

          notifications.show({
            title: 'Operation Failed',
            message: `Could not find volunteer ${id}`,
          });
        }
      } catch (error) {
        console.error('fetchVolunteer:error', error);

        notifications.show({
          title: 'Operation Failed',
          message: error.message,
        });
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchVolunteer();
    }
  }, [id]);

  const handleUpdateVolunteer = async (data) => {
    console.log('handleUpdateVolunter:data', data);

    setLoading(true);

    try {
      const volunteers = collection(db, 'volunteers');

      if (data.email !== volunteer.email) {
        const q = query(volunteers, where('email', '==', data.email));
        const snapshot = await getDocs(q);
        console.log('handleUpdateVolunteer:snapshot', snapshot);

        if (snapshot.empty === false) {
          throw Error(`Email ${data.email} already exists. Please use a different email`);
        }
      }

      data.uat = new Date();

      await updateDoc(doc(db, 'volunteers', id), data);

      notifications.show({
        title: 'Operation Success',
        message: `Volunteer ${data.name.first} ${data.name.last} updated successfully`,
      });
    } catch (error) {
      console.error('handleUpdateVolunter:error', error);

      notifications.show({
        title: 'Operation Failed',
        message: error.message,
      });
    } finally {
      setLoading(false);
    }
  }

  const isLoadingOverlayBoxVisible = loading;

  return (
    <Frame label="Volunteer List" href="/volunteer/list">
      <Paper withBorder shadow="sm" radius="md" p={18}>
        <LoadingOverlayBox visible={isLoadingOverlayBoxVisible}>
          <Title order={3}>Add Volunteer</Title>
          <Text size="sm" mb="md">
            {id}
          </Text>

          <VolunteerForm onSubmit={handleUpdateVolunteer} volunteer={volunteer} />
        </LoadingOverlayBox>
      </Paper>
    </Frame>
  );
};

export default Update;